import React, { useState } from "react";

import ImageCard from "./ImageCard";
import TitleHeader from "./TitleHeader";
import { Row, Col, Modal, Button } from "react-bootstrap"; // Import Modal and Button from react-bootstrap
import { NavLink, useParams } from 'react-router-dom';
import useApidata from "../../hooks/useApidata";

export const HomeCategory = ({ posts, categoryId, title }) => {

    const [selectedItem, setSelectedItem] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const categoryPosts = posts.filter(
        post => post.category_id === categoryId
    );

    const openModal = (item) => {
        setSelectedItem(item);
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
    }

    // ✅ remove sandbox from iframe
    const cleanedHtml = selectedItem?.post_body?.replace(/sandbox="[^"]*"/g, "");

    if (categoryPosts.length === 0) return null;

    return (
        <>
            <TitleHeader
                title={title}
                slug={categoryPosts[0]?.category_slug}
                viewall="View all"
                c_id={categoryId}
            />

            <Row>
                {categoryPosts.slice(0, 3).map((item) => (
                    item.category_name === "Videos" ? (
                        <Col key={item.id} lg={4} md={4} className="imagecard-main-image">
                            <div onClick={() => openModal(item)}>
                                <ImageCard
                                    image={item.post_images?.desktop_banner?.[0]?.original}
                                    discription={item.title}
                                    category_name={item.category_name}
                                    published_date={item.published_on}
                                />
                            </div>
                        </Col>
                    ) : (
                        <Col key={item.id} lg={4} md={4} className="imagecard-main-image">
                            <NavLink to={`/Detail/${item.slug}`}>
                                <ImageCard
                                    image={item.post_images?.desktop_banner?.[0]?.original}
                                    discription={item.title}
                                    category_name={item.category_name}
                                    published_date={item.published_on}
                                />
                            </NavLink>
                        </Col>
                    )
                ))}
            </Row>

            <Modal show={showModal} onHide={closeModal} size="lg">
                <Modal.Header closeButton>
                    {selectedItem && <h5>{selectedItem.title}</h5>}
                </Modal.Header>

                <Modal.Body>
                    {cleanedHtml ? (
                        <div
                            dangerouslySetInnerHTML={{ __html: cleanedHtml }}
                            className="poo_utube_video"
                        />
                    ) : (
                        <p>No content available</p>
                    )}
                </Modal.Body>
            </Modal>
        </>
    );
};